import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { PTA_PROTOCOL_ITEMS } from './ptaProtocolConstants';

const PtaProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="PTA"
            title="PTA JOB DESCRIPTION"
            items={PTA_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default PtaProtocol;
